/**
 * Delete Enhancement Bundle API
 * Feature: 023-flexible-training-product
 */

import axiosInstance from '../../axiosInstance';

export const deleteEnhancementBundle = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/api/enhancement-bundles/${id}`);
};
